import classNames from 'classnames';
import styles from './FJSingleRadio.module.less';

const FJSingleRadio = props => {
    const { active, className } = props;
    const cn = classNames(styles.box, active ? styles.active : null, className);
    return (
        <div className={cn}>
            <span className={styles.icon_inner} />
        </div>
    );
};

export default FJSingleRadio;
